// TODO refactor: this has a lot of similarities with @\modules\financial\subpages\predictions-tab\subpages\recommendations\recommendations-module.js

import * as apiTo from '@/modular-api'

export default {
  namespaced: true,

  state: () => ({
    totalRows: 0,
    rowsSelected: [],
    selectAll: false,
    statuses: [],
    recommendationStatuses: [],
    selectedDepartment: null,
    refreshCardsHandler: 0, // whenever we change this, departmentInfo and totalInfo cards will re-fetch
    refreshTableHandler: 0, // whenever we change this, table will re-fetch
    dataForBatchDecisionMaking: null,
    filterInProgress: false
  }),

  getters: {
    numberOfSelectedRows(state) {
      if (state.selectAll) {
        return state.totalRows - state.rowsSelected.length
      }
      return state.rowsSelected.length
    }
  },

  mutations: {
    setTotalRows: (state, payload) => (state.totalRows = payload),
    setRowsSelected: (state, payload) => (state.rowsSelected = payload),
    setSelectAll: (state, payload) => (state.selectAll = payload),
    setStatuses: (state, payload) => (state.statuses = payload),
    setRecommendationStatuses: (state, payload) => (state.recommendationStatuses = payload),
    setSelectedDepartment: (state, payload) => (state.selectedDepartment = payload),
    refreshCards: state => state.refreshCardsHandler++,
    refreshTable: state => state.refreshTableHandler++,
    setDataForBatchDecisionMaking: (state, payload) => (state.dataForBatchDecisionMaking = payload),
    setFilterInProgress: (state, payload) => (state.filterInProgress = payload)
  },

  actions: {
    getAndSetStatuses({ commit }) {
      return apiTo.GET_SUB_PERIOD_PROPOSAL_STATUSES().then(({ data }) => commit('setStatuses', data.result))
    },

    getAndSetRecommendationStatuses({ commit }) {
      return apiTo
        .GET_SUB_PERIOD_RECOMMENDATION_STATUSES()
        .then(({ data }) => commit('setRecommendationStatuses', data.result))
    },

    getAndSetDataForBatchDecisionMaking({ commit }, payload) {
      return apiTo
        .GET_PROPOSAL_STATUSES_WITH_SUB_IDS(payload)
        .then(({ data }) => commit('setDataForBatchDecisionMaking', data.result))
    }
  }
}
